import { useMutation, useQuery } from "react-query";
import api from "../api";
import { API_ROUTES } from "../../utils/const";
import { TRANSACTIONS_TIMEOUT } from "../../utils/const";

const FETCH_ALL_TRANSACTIONS = async (data) => {
    const response = await api.post(
        API_ROUTES.GET_ALL_TRANSACTIONS,
        data,
        { timeout: TRANSACTIONS_TIMEOUT }
    )
    return response.data
}

export const getAllTransactions = (data) => {
    return useQuery({
        queryKey: ['allTransactions', data],
        queryFn: () => FETCH_ALL_TRANSACTIONS(data),
        enabled: !!data.business
    })
}

const INITIATE_TRANSACTIONS_EXPORT_CACHE = async (data) => {
    const response = await api.post(
        API_ROUTES.INITIATE_TRANSACTIONS_EXPORT_CACHE,
        data
    )
    return response.data
}

const DISPATCH_TRANSACTIONS_EXPORT_TO_EMAIL = async(requestId) => {
    const response = await api.get(
        `${API_ROUTES.DISPATCH_TRANSACTIONS_EXPORT_TO_EMAIL}/${requestId}`
    )
    return response.data
}

export const useTransactionsExport = () => {
    return useMutation({
        mutationFn: async (data: { business: string; format: string; startDay: string; endDay: string }) => {
            const initiateCache = await INITIATE_TRANSACTIONS_EXPORT_CACHE(data);
            const dispatchExportToEmail = await DISPATCH_TRANSACTIONS_EXPORT_TO_EMAIL(initiateCache.requestId);
            return dispatchExportToEmail;
        }
    })
}